class SubscriptionWidget extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
    this.initPopup();
  }

  init() {
    this.formId = this.getAttribute('data-form-id');
    this.sellingPlanFields = this.querySelectorAll('[js-selling-plan-field]');
    this.sellingPlanLabel = this.querySelector('[js-subscription-plan-label]');

    this.addEventListener('change', this.handleSubscription.bind(this));
  }

  handleSubscription({ target }) {
    if (target.hasAttribute('js-purchase-field')) {
      if (target.getAttribute('is') === 'subscription') {
        this.sellingPlanFields.forEach(field =>
          field.setAttribute('form', this.formId)
        );
      } else {
        this.sellingPlanFields.forEach(field =>
          field.removeAttribute('form')
        );
      }
    }

    if (target.getAttribute('is') === 'selling-plan') {
      const selectedPlanField = this.querySelector('[js-selling-plan-field]:checked');
      if(this.sellingPlanLabel && selectedPlanField) {
        this.sellingPlanLabel.textContent = selectedPlanField.getAttribute("data-value");
      };

      this.closePopup();
    }
  }

  initPopup() {
    this.popup = this.querySelector('.js-subscribe-popup');
    if (!this.popup) return;

    this.openBtns = this.querySelectorAll('.js-subscribe-popup-open');
    this.closeBtn = this.popup.querySelector('.js-subscribe-popup-close');

    this.openBtns?.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.stopPropagation();
        this.openPopup(e);
      });
    });

    this.closeBtn?.addEventListener('click', (e) => {
      this.closePopup(e);
    });

    this._onOutsideClick = (e) => {
      if (!this.popup.classList.contains('is-open')) return;
      if (this.popup.contains(e.target) || this.openBtn?.contains(e.target)) return;

      this.closePopup();
    };

    document.addEventListener('click', this._onOutsideClick);
  }

  openPopup(e) {
    if (e) e.preventDefault();
    this.popup.classList.add('is-open');
    this.popup.setAttribute('aria-hidden', 'false');
  }

  closePopup(e) {
    if (e) e.preventDefault();
    this.popup.classList.remove('is-open');
    this.popup.setAttribute('aria-hidden', 'true');
  }

  disconnectedCallback() {
    if (this._onOutsideClick) {
      document.removeEventListener('click', this._onOutsideClick);
    }
  }
}

customElements.define('subscription-widget', SubscriptionWidget);

(function () {
  const PRODUCT_FORM_SELECTOR = 'product-form-component';
  const SEALSUBS_SELECTOR = '.sealsubs-target-element';

  function removeSealSubs(root) {
    const el = root.querySelector(SEALSUBS_SELECTOR);
    if (el) {
      el.remove();
    }
  }

  function init(productForm) {
    if (!productForm) return;

    productForm.addEventListener('change', () => {
      removeSealSubs(productForm);
    });

    const observer = new MutationObserver(() => {
      removeSealSubs(productForm);
    });

    observer.observe(productForm, {
      childList: true,
      subtree: true,
    });
  }

  document.querySelectorAll(PRODUCT_FORM_SELECTOR).forEach(init);

  const rootObserver = new MutationObserver(() => {
    document.querySelectorAll(PRODUCT_FORM_SELECTOR).forEach(init);
  });

  rootObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();